import React from 'react'
import { Input } from 'antd'

interface TypeColorSelectProps {
    'aria-label'?: string
    disabled?: boolean
    onChange?: (value: string) => void
    value?: string
}

const TypeColorSelect: React.FC<TypeColorSelectProps> = ({
    disabled,
    onChange,
    value,
    'aria-label': ariaLabel,
}) => {
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        onChange?.(event.target.value.toLowerCase())
    }

    return (
        <Input
            aria-label={ariaLabel}
            disabled={disabled}
            onChange={handleChange}
            style={{ height: 40, maxWidth: 96 }}
            type="color"
            value={value}
        />
    )
}

export default TypeColorSelect
